import { AfterViewInit, Component } from '@angular/core';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements AfterViewInit {
  title = 'op-angular';
  timerLoading: any;
  constructor(
    private messageService: MessageService
  ) {}

  onConfirm(): void {
    this.messageService.clear('custom-message');
  }

  ngAfterViewInit(): void {
    // clearTimeout(this.timerLoading);
    // this.timerLoading = setTimeout(() => {
    //   const el = document.getElementsByClassName('active-menuitem');
    //   el.item(0).scrollIntoView();
    // }, 500);
  }
}
